//https://www.wrike.com/open.htm?id=1246296889
class ProductBundlePopup extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector('[data-close-btn]');
    this.querySelectorAll('[data-close-btn]').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    this.classList.add('hidden');
  }

}
class ProductBundlePopupContainer extends HTMLElement {
  constructor() {
    super();
    this.currentProduct = this.getProductJSON();
    this.wrapper = this.querySelector('[data-product-bundle-popup-container]');
    this.toggler = this.querySelector('[data-product-bundle-popup-toggler]');
    this.toggler?.addEventListener('click', this.onClickToggler.bind(this));
    this.inCart = this.dataset.inCart;
    this.init();
  }

  init() {
    this.fetchCart(this.buildMessages.bind(this));
  }

  onClickToggler() {
    this.wrapper.classList.toggle('hidden');
    this.toggler.classList.toggle('is-active');
  }

  getProductJSON() {
    var productJSON = document.querySelector('[data-product-json]');
    if(productJSON) {
      return JSON.parse(productJSON.innerHTML);
    }
    return null;
  }

  buildMessages(data) {
    this.wrapper.innerHTML = '';
    if(!this.inCart) {
      theme.campaigns.forEach(campaign => {
        campaign.buildCartMessage(data, this.buildMessagesCallback.bind(this), this.currentProduct);
      })
    } else {
      theme.campaigns.forEach(campaign => {
        campaign.buildCartMessage(data, this.buildMessagesCallback.bind(this));
      })
    }
  }

  buildMessagesCallback(body, id, persistent, priority, url, min, count) {
    this.initBundlePopup(body, url, min, count);
  }

  initBundlePopup(body, url, min, count) {

    console.log('do init bundle popup...')
    var countForMessage = isNaN(count) ? `Buy ${ min } to complete the bundle!` : `Buy ${min - count} more item(s) to complete the bundle!`;
    var popupHTML = `<product-bundle-popup class="product-bundles-popup">
      <div class="product-bundles-popup__tag">Bundle</div>
      <button class="product-bundles-popup__close-btn" data-close-btn="">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M15 5L5 15" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M5 5L15 15" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
      </button>
      <div class="product-bundles-popup__title">${body}</div>
      <div class="product-bundles-popup__desc">${ countForMessage }</div>
      <a href="${url}" class="product-bundles-popup__link">Shop Bundle <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3.33301 8H12.6663" stroke="#E41B24" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="#E41B24" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg></a>
    </product-bundle-popup>`;
    this.wrapper.innerHTML = this.wrapper.innerHTML + popupHTML;
  }

  async fetchCart (callback) {
    const response = await fetch(`${routes.cart_url}.js`);
    const data = await response.json();
    callback(data);
  }
}

class ProductBundleSlider extends ProductBundlePopupContainer {
  constructor() {
    super();
  }

  init() {

    customElements.whenDefined('swiper-container')
         .then(()=>{
      this.addListeners();
      this.defineElements();
      this.defineOptions();
      this.startSlider();
      this.calculateOverflowSize();
      super.init();
    });


  }

  update() {
    window.customElements.whenDefined('swiper-container')
        .then(()=> {

      if (this.inCart) {
        this.startSlider();
      }
    this.hiddenSection();
    this.defineOptions();
    this.clearSlider();
    this.calculateOverflowSize();
    super.init();
    });

  }

  defineOptions() {

    this._isOpened = this.hasAttribute('open');
    this.inCart = this.hasAttribute('in-cart');
    this.ids = [];
    this._showSection = false;


    this.sliderOptions = {
      slidesPerView: this.inCart? 1.55 : 2.5,
      spaceBetween: 8,
      draggable: true,
      scrollbar: {
        el: this.scrollbar,
        draggable: true
      },
      autoplay: {
        delay: 5000,
        enabled: true,
        pauseOnMouseEnter: true
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      },
      grabCursor: true,
      breakpoints: {
        992: {
          slidesPerView:this.inCart? 1.55 : 2.5
        },
        1600: {
          slidesPerView:this.inCart? 1.55 : 3
        }
      },
    };
  }

  defineElements() {
    this.slider =
        this.querySelector('swiper-container');
    this.buttonPrev =
        this.querySelector('[data-swiper-custom-button-prev]');
    this.buttonNext =
        this.querySelector('[data-swiper-custom-button-next]');
    this.scrollbar =
        this.querySelector('[data-swiper-custom-scrollbar]');
    this.wrapperOverflow =
        this.querySelector('[data-swiper-custom-overflow]');
    this.count =
        this.querySelector('[data-product-bundle-count]');
  }

  startSlider(options = this.sliderOptions) {
    Object.assign(this.slider, options);
    this.slider.initialize();
  }

  clearSlider() {
    if (this.slider.swiper && this.slider.swiper.removeAllSlides) {
      this.slider.swiper.removeAllSlides();
    }
  }

  addListeners() {
    document.addEventListener(
        'bundle::trigger-slider-update',
        this.update.bind(this)
    );

      window.addEventListener(
          'resize',
          this.calculateOverflowSize.bind(this)
      );

    this.customDelegate(
        "click",
        'bundle-title',
        this.fieldClickHandler.bind(this)
    )
  }

  toggleDropdown(show) {
    show = (show !== undefined) ? show : !this._isOpened;
    this._isOpened = show;
    this._isOpened ?
        this.setAttribute('open','') :
        this.removeAttribute('open');
        this.slider.swiper.update();
        this.slider.swiper.updateProgress();
  };

  fieldClickHandler() {
    this._isOpened ? this.close() : this.open();
  };

  close() {
    this.toggleDropdown(false);
  };

  open() {
    this.toggleDropdown(true);
  }

  showSection() {
    if (!this._showSection) {
        this.removeAttribute('default-hidden');
        this.calculateOverflowSize()
        this.slider?.swiper?.update();
    }
  }

  hiddenSection() {
    if (this._showSection) {
        this.setAttribute('default-hidden','');
    }
  }

  calculateOverflowSize() {

    if (this.inCart) {
      return null
    }

    const rect =
        this.getBoundingClientRect();
    const position =
        window.innerWidth - rect.right;

    this.wrapperOverflow?.style.setProperty('width', `calc(100% + ${position}px)`);
  }

  styleWithoutSlider(count) {
    if (count > 2) {
      this.removeAttribute('without-slider');
    } else {
      this.setAttribute('without-slider','');
    }
  }

  updateSwiperPosition() {
    this.slider?.swiper?.update();
    this.slider?.swiper?.updateProgress();
  }

  startAutoPlay() {
    this.slider?.swiper?.autoplay?.start();
  }

  buildMessages(data) {
    if(!this.inCart) {
      theme.campaigns.forEach(campaign => {
        campaign.buildCartMessage(data, this.buildMessagesCallback.bind(this), this.currentProduct);
      })
    } else {
      theme.campaigns.forEach(campaign => {
        campaign.buildCartMessage(data, this.buildMessagesCallback.bind(this));
      })
    }
  }

  buildMessagesCallback(body, id, persistent, priority, url, min, count) {
    this.buildSlider(body, url, min, count, id);
  }

  buildSlider(body, url, min, count, id) {

    if (this?.ids?.includes(id)) {
      return null;
    }
// move to template (no time)
    var countForMessage = isNaN(count) ? `Buy ${ min } to complete the bundle!` : `Buy ${min - count} more item(s) to complete the bundle!`;
    var slide = `<swiper-slide class="product-bundles-slide">
      <div class="product-bundles-slide__title">${body}</div>
      <div class="product-bundles-slide__desc">${ countForMessage }</div>
      <a href="${url}" class="product-bundles-slide__link">Shop Bundle <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3.33301 8H12.6663" stroke="#E41B24" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="#E41B24" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg></a>
    </swiper-slide>`;


    this.slider?.insertAdjacentHTML( 'beforeend', slide );

    this.showSection();
    this._showSection = true;
    this.updateSwiperPosition();

    const sliderCount = this.slider?.swiper?.slides?.length || '';

    this.count.innerHTML = `(${sliderCount})`;

    this?.ids?.push(id);
    this.styleWithoutSlider(sliderCount);
    this.startAutoPlay();

  }

  customDelegate(eventName, elementSelector, handler) {
    this.addEventListener(eventName, (e) => {
      const element = e.target.closest(elementSelector);
      if (element) {
        handler.call(element, e, element);
      }
    }, false);
  };


}


customElements.define('product-bundle-popup', ProductBundlePopup);
customElements.define('product-bundle-popup-container', ProductBundlePopupContainer);
customElements.define('component-product-bundle-slider', ProductBundleSlider);
